module.exports = [{
      plugin: require('../node_modules/gatsby-source-yotpo-shopify/gatsby-browser.js'),
      options: {"plugins":[],"shopName":"staging-open-spaces","shopifyAccessToken":"f3ae8f49fb9f95d457267df187e205a4","yotpoAppKey":"ZeRrKfF4nkqsine9j2IVgdGOmpHCvbVu9c3GjpUt","appendDefaultObject":false,"createDefaultObject":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Pattern Brands","short_name":"PB","start_url":"/","background_color":"#F0EBE5","theme_color":"#0B474B","display":"minimal-ui","icon":"src/assets/images/os-favicon-512x512.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"bc022552799737feb85aa66ae15a2ed8"},
    },{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-loadable-components-ssr/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
